"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorResponse = isErrorResponse;
exports.isHealthResponse = isHealthResponse;
exports.isCompleteWeatherResponse = isCompleteWeatherResponse;
// ============================================================================
// Type Guards (för runtime type checking)
// ============================================================================
function isErrorResponse(response) {
    return response && typeof response.error === 'string';
}
function isHealthResponse(response) {
    return response && typeof response.status === 'string' && typeof response.timestamp === 'string';
}
function isCompleteWeatherResponse(response) {
    return response && response.location && response.current && response.hourly && response.daily && response.fishing;
}
